import { c as _c } from "react/compiler-runtime";
import type { UpsertJobOfferInputDTO } from '@algoacademy/backend/modules/career/endpoints/mutations/upsert-job-offer/input.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { LightCard } from '@algoacademy/design-system/web/data-display/Card';
import { ErrorMessage, Field } from '@algoacademy/design-system/web/forms/Fieldset';
import { Input } from '@algoacademy/design-system/web/forms/Input';
import { Textarea } from '@algoacademy/design-system/web/forms/Textarea';
import { H4 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { Label2 } from '@algoacademy/design-system/web/typography/Label';
import { PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useFieldArray, useFormContext } from 'react-hook-form';
export function RecruitmentProcessSection() {
  const $ = _c(19);
  const {
    control,
    register,
    formState: t0
  } = useFormContext();
  const {
    errors
  } = t0;
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "recruitmentProcess"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <H4>Jak wygląda proces rekrutacyjny?</H4>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== errors || $[4] !== fields || $[5] !== register || $[6] !== remove) {
    t3 = fields.length > 0 && fields.map((recruitmentProcessStep, index) => <LightCard key={recruitmentProcessStep.id} className="space-y-4 border-borderSecondary bg-backgroundSecondary p-6"><div className="flex flex-row items-center justify-between gap-6"><Field className="flex-1"><Label2>Nazwa etapu</Label2><Input placeholder="Nazwa etapu" {...register(`recruitmentProcess.${index}.step`)} /><ErrorMessage>{errors.recruitmentProcess?.[index]?.step?.message ?? ""}</ErrorMessage></Field><Button color="destructive" onClick={() => remove(index)} className="mt-5"><TrashIcon className="size-4" /> Usuń etap</Button></div><Field><Label2>Opis etapu</Label2><Textarea placeholder="Opis etapu" rows={4} {...register(`recruitmentProcess.${index}.description`)} /><ErrorMessage>{errors.recruitmentProcess?.[index]?.description?.message ?? ""}</ErrorMessage></Field></LightCard>);
    $[3] = errors;
    $[4] = fields;
    $[5] = register;
    $[6] = remove;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="space-y-6">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== append || $[11] !== fields.length) {
    t5 = () => append({
      step: "",
      description: "",
      order: fields.length
    });
    $[10] = append;
    $[11] = fields.length;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <PlusIcon className="size-4" />;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5) {
    t7 = <div className="flex justify-start"><Button type="button" onClick={t5}>{t6}Dodaj etap</Button></div>;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t4 || $[17] !== t7) {
    t8 = <LightCard className="space-y-4 p-6">{t2}{t4}{t7}</LightCard>;
    $[16] = t4;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}